// LP の view（HAML と client/lp_photos.ts・React の RoomInfo）がグローバルとして使う外部ライブラリ。
// 以前は CDN の <script>（版固定 + SRI）で読んでいたが、npm で管理して Dependabot の更新対象にするためバンドルした。
// fslightbox は読み込むだけで window.refreshFsLightbox / fsLightboxInstances / FsLightbox を定義する。
// embla は client/reservation_lp.ts が直接 import する（グローバルにしない。#2311）
import 'fslightbox'
